export enum ModalTypes{
    Dialog = 'Dialog',
    DialogRightSide = 'DialogRightSide',
    DialogLeftSide = 'DialogLeftSide',
    BottomSheet = 'BottomSheet',
}